import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ImagedDocument } from '../models/imaged-document.model';

@Injectable({
  providedIn: 'root'
})
export class ImagedDocumentService {

  constructor(private apiService: ApiService) { }

  /**
   * Get the documents records from ESB for a specific loan
   *
   * @param id The loan requested
   */
  public getDocumentsByLoanId(id: string, cursor: string, documentName: string, sortby: string): any {
    if (id) {

      let data = {
        "accountNumber": id,
        "accountType": "CMC",
        "cursor": cursor,
        "sortBy": sortby
      }

      if (documentName !== "All") data["documentName"] = documentName;

      console.log("data", data);
      return this.apiService.post(`/docs/${id}`, data);
    }
  }

  public getDocumentById(loanId: string, docId: string): Promise<any> {
    if (docId) {
      const data = {
        "documentId": docId
      }

      return this.apiService.postPDF(`/docs/${loanId}/${docId}`, data, 'application/json','application/pdf');
    }
  }
}
